enum RollerCoasterPrizeType {
    JackpotTier1 = 'jackpot-tier-1',
    JackpotTier2 = 'jackpot-tier-2',
    Prize = 'prize'
}

function getPrizeTypeName(prizeType: RollerCoasterPrizeType) {
    switch (prizeType) {
      case RollerCoasterPrizeType.Prize:
        return 'Prize';
      case RollerCoasterPrizeType.JackpotTier1:
        return 'Jackpot in 5';
    case RollerCoasterPrizeType.JackpotTier2:
        return 'Jackpot in 6';
    }
}

export { RollerCoasterPrizeType, getPrizeTypeName };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/roller-coaster/_domain/models/prize-type.ts